let Search = function (text, categories) {
    this.text = text || '';
    this.link = text ? encodeURIComponent(text) : '';
    this.categories = categories || [];
};

module.exports = Search;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/models/search.js